import { render, staticRenderFns } from "./SalesTickets.vue?vue&type=template&id=19addda1&scoped=true&"
import script from "./SalesTickets.vue?vue&type=script&lang=js&"
export * from "./SalesTickets.vue?vue&type=script&lang=js&"
import style0 from "./SalesTickets.vue?vue&type=style&index=0&id=19addda1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19addda1",
  null
  
)

export default component.exports